import {ajaxURL} from "../WooCommerce/wooConfig";

export const addToWishlist = (e, databaseId, setAddedToWishlist, setWishlist) => {
    e.preventDefault();
    setAddedToWishlist({
        loading: true,
    });
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'text/html, */*; q=0.01',
            'Accept-Encoding': 'gzip, deflate',
            'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
        },
        body: `action=wishlist-action-add&product_id=${databaseId}`
    };
    fetch(ajaxURL, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.error) {
                    setAddedToWishlist({
                        loading: false,
                        error: true
                    });
                    return;
                }
                setAddedToWishlist({
                    loading: false,
                    added: true
                });
                setWishlist(result);
            },
            (error) => {
                setAddedToWishlist({
                    loading: false,
                    error: true
                });
            }
        )
};

export const removeFromWishlist = (e, databaseId, setAddedToWishlist, setWishlist) => {
    e.preventDefault();
    setAddedToWishlist({
        loading: true,
    });
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'text/html, */*; q=0.01',
            'Accept-Encoding': 'gzip, deflate',
            'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
        },
        body: `action=wishlist-action-remove&product_id=${databaseId}`
    };
    fetch(ajaxURL, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.error) {
                    setAddedToWishlist({
                        loading: false,
                        error: true,
                        added: true
                    });
                    return;
                }
                setAddedToWishlist({
                    loading: false,
                    added: false
                });
                setWishlist(result);
            },
            (error) => {
                setAddedToWishlist({
                    loading: false,
                    error: true,
                    added: true
                });
            }
        )
};
